import React from 'react'
import fiveHundred from 'src/assets/images/500.svg'
import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'
import './error.scss'

export function InternalServerError() {
    return <Error title="Internal server error" errorCode="500" />
}

export const NotFound = () => {
    return <Error title="Page not found" errorCode="404" />
}

function Error(props) {
    return (
        <Grid.Container className={'page-body error-page'}>
            <h1 className={'error-title'}>{props.title}</h1>
            <p className={'error-status fz-8 stix-text-center'}>
                {props.errorCode}
            </p>
            <div
                style={{
                    maxWidth: '50%',
                    margin: 'auto',
                }}
            >
                <img
                    src={fiveHundred}
                    alt={'An error has occurred while processing your request.'}
                />
            </div>
        </Grid.Container>
    )
}
